import { authApiService } from '../../authApiService';
import { ApiParams } from '../../helpers/apiHelpers';
import { ApiResponseType } from '@/types/sharedTypes';
import { AssignedWireType } from '@/types/wireTypes';
import { WIRE_STATUS_DB } from '@/const/wire';

type ChangeStatusDataType = {
  status: typeof WIRE_STATUS_DB.RECIPIENT_ASSIGNED;
};

export const recipientChangeWireStatusApi = (
  id: string,
  data: ChangeStatusDataType,
  params?: ApiParams
): Promise<ApiResponseType<AssignedWireType>> => {
  const uri = `/recipient/wires/${id}/status/`;

  return authApiService.PATCH(uri, data, params);
};
